import React from "react";
import { useTranslation } from "react-i18next";

import { useRetrieveWorkloadProjects } from "@planzone/view-models";
import { Flag } from "@common/infiniteScroll";
import { ProjectRow } from "./projectRow";
import { LoaderRow } from "./loaderRow";
import { Props } from "./types";
import styles from "./styles.scss";

const DETAIL_PAGE_SIZE = 20;

function ProjectsDetail(props: Props) {
  const { t } = useTranslation();
  const sort = props.sort === "ROLE" ? "ALPHABETICAL" : props.sort;
  const {
    isRequestPending,
    isRequestSuccess,
    isRequestFailure,
    content,
    currentPage,
    canLoadMore,
    retrieveWorkloadProjects,
  } = useRetrieveWorkloadProjects(
    props.resourceId,
    props.from,
    props.to,
    props.granularity,
    props.filter,
    sort,
    DETAIL_PAGE_SIZE,
  );

  const retrieveCurrentPage = () =>
    retrieveWorkloadProjects({
      resourceId: props.resourceId,
      from: props.from,
      to: props.to,
      granularity: props.granularity,
      filter: props.filter,
      sort,
      page: currentPage,
      size: DETAIL_PAGE_SIZE,
    });

  const rowWidth = `${28 + props.periodsCount * 10}rem`;

  return (
    <React.Fragment>
      {isRequestFailure && content.length === 0 ? (
        <div className={styles.state} style={{ width: rowWidth }}>
          <p>{t("workloadPage.table.detailError")}</p>
          <p className={styles.retry} onClick={retrieveCurrentPage}>
            {t("workloadPage.retry")}
          </p>
        </div>
      ) : isRequestSuccess && content.length === 0 ? (
        <div className={styles.state} style={{ width: rowWidth }}>
          <p>{t("workloadPage.table.detailEmpty")}</p>
        </div>
      ) : (
        <React.Fragment>
          {content.map((project) => (
            <ProjectRow
              key={project.uuid}
              resourceId={props.resourceId}
              project={project}
              granularity={props.granularity}
              locale={props.locale}
              canEdit={props.canEdit}
            />
          ))}
          {isRequestPending &&
            Array.from({ length: content.length === 0 ? 3 : 1 }, (_, index) => (
              <LoaderRow key={index} columns={props.periodsCount} />
            ))}
          <div>
            <Flag
              name={`workloadProjects-${props.resourceId}`}
              isDisabled={isRequestPending || !canLoadMore}
              retrieveItems={retrieveCurrentPage}
            />
          </div>
        </React.Fragment>
      )}
    </React.Fragment>
  );
}

export { ProjectsDetail };
